import { render, staticRenderFns } from "./ImageAndTextPortfolio.vue?vue&type=template&id=656fbb3f"
import script from "./ImageAndTextPortfolio.vue?vue&type=script&lang=js"
export * from "./ImageAndTextPortfolio.vue?vue&type=script&lang=js"
import style0 from "./ImageAndTextPortfolio.vue?vue&type=style&index=0&id=656fbb3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports